const RangeOperator = Object.freeze({
	within: '_IN_',
	between: { min: '_BETWEEN_', max: '_AND_' },
});

export default RangeOperator;
